module.exports = __webpack_public_path__ + "img/inner_6_bg.16c61fc4.png";